import React, {useContext, useEffect} from "react";
import {Link, useLocation, useNavigate} from "react-router-dom";
import ic_sidemenu_toggle from "../assets/images/ic_sidemenu_toggle.svg";
import {useMediaQuery} from "react-responsive";
import ic_dashboard from "../assets/images/ic_dashboard.svg";
import ic_admin from "../assets/images/ic_admin.svg";

import ic_about from "../assets/images/ic_about.svg";
import ic_category from "../assets/images/ic_category.svg";
import ic_machine from "../assets/images/ic_machine.svg";
import ic_order from "../assets/images/ic_order.svg";
import ic_privacy from "../assets/images/ic_privacy.svg";
import ic_product from "../assets/images/ic_product.svg";
import ic_term from "../assets/images/ic_term.svg";
import ic_user from "../assets/images/ic_user.svg";
import ic_coupon_code from "../assets/images/ic_coupon_code.svg";

import {AppContext} from "../context/AppContext";

const Sidebar = () => {
    const navigate = useNavigate();
    const currentRoute = useLocation().pathname;
    const isMobile = useMediaQuery({
        query: "(max-width: 768px)",
    });

    useEffect(() => {
        isMobile ? setSidebar(false) : setSidebar(true);
        return () => {
        };
    }, [isMobile]);

    const {sidebar, setSidebar, Dark, customerData} = useContext(AppContext);
    const handleSidebar = () => {
        setSidebar(!sidebar);
    };

    return (<main className="cx-sidebar">
        <div
            className={sidebar ? "cx-sidebar-wrapper " : "cx-sidebar-wrapper sidebarActive"}
        >
            <aside>
                <div className={sidebar ? "top-logo-big" : "top-logo-big displayNone"}>
                    <div className="left">
                        <h6>WELCOME</h6>
                        <span>{customerData?.email}</span>
                    </div>
                </div>


                <div className="left-arrow"></div>

                <div className="menus-main">
                    <div className="menus-items" id="arrow-double">
                        <div
                            className={sidebar ? "text-end " : "doubleArrowActive"}
                            onClick={handleSidebar}
                            id="arrow-inner"
                        >
                            <img src={ic_sidemenu_toggle} alt=""/>
                        </div>
                    </div>

                    <div
                        className={currentRoute === "/Dashboard" ? "menus-items  active-menu-sidebar" : "menus-items"}
                    >
                        <Link to="/Dashboard" className="icon-menu-name">
                            {sidebar ? (<div className={"menu-name"}>
                                <Link to="/dashboard" className="me-2">
                                    {currentRoute === "/Dashboard" ? (<img src={ic_dashboard} alt=""/>) : (<svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        width="1em"
                                        height="1em"
                                        preserveAspectRatio="xMidYMid meet"
                                        viewBox="0 0 24 24"
                                    >
                                        <path
                                            fill="#16173b"
                                            d="M4 13h6c.55 0 1-.45 1-1V4c0-.55-.45-1-1-1H4c-.55 0-1 .45-1 1v8c0 .55.45 1 1 1zm0 8h6c.55 0 1-.45 1-1v-4c0-.55-.45-1-1-1H4c-.55 0-1 .45-1 1v4c0 .55.45 1 1 1zm10 0h6c.55 0 1-.45 1-1v-8c0-.55-.45-1-1-1h-6c-.55 0-1 .45-1 1v8c0 .55.45 1 1 1zM13 4v4c0 .55.45 1 1 1h6c.55 0 1-.45 1-1V4c0-.55-.45-1-1-1h-6c-.55 0-1 .45-1 1z"
                                        />
                                    </svg>)}
                                </Link>
                                Dashboard
                            </div>) : (<div className="icon-left">
                                {currentRoute === "/Dashboard" ? (<img src={ic_dashboard} alt=""/>) : (<svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="1em"
                                    height="1em"
                                    preserveAspectRatio="xMidYMid meet"
                                    viewBox="0 0 24 24"
                                >
                                    <path
                                        fill="#16173b"
                                        d="M4 13h6c.55 0 1-.45 1-1V4c0-.55-.45-1-1-1H4c-.55 0-1 .45-1 1v8c0 .55.45 1 1 1zm0 8h6c.55 0 1-.45 1-1v-4c0-.55-.45-1-1-1H4c-.55 0-1 .45-1 1v4c0 .55.45 1 1 1zm10 0h6c.55 0 1-.45 1-1v-8c0-.55-.45-1-1-1h-6c-.55 0-1 .45-1 1v8c0 .55.45 1 1 1zM13 4v4c0 .55.45 1 1 1h6c.55 0 1-.45 1-1V4c0-.55-.45-1-1-1h-6c-.55 0-1 .45-1 1z"
                                    />
                                </svg>)}
                            </div>)}
                        </Link>
                    </div>

                    <div
                        className={currentRoute === "/Admin" ? "menus-items  active-menu-sidebar" : "menus-items"}
                    >
                        <Link to="/Admin" className="icon-menu-name">
                            {sidebar ? (<div className={"menu-name"}>
                                <Link to="/Admin" className="me-2">
                                    {currentRoute === "/Admin" ? (<img src={ic_admin} alt=""/>) : (<svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        width="16"
                                        height="16"
                                        fill="#16173b"
                                        className="bi bi-people-fill"
                                        viewBox="0 0 16 16"
                                    >
                                        <path
                                            d="M7 14s-1 0-1-1 1-4 5-4 5 3 5 4-1 1-1 1H7Zm4-6a3 3 0 1 0 0-6 3 3 0 0 0 0 6Zm-5.784 6A2.238 2.238 0 0 1 5 13c0-1.355.68-2.75 1.936-3.72A6.325 6.325 0 0 0 5 9c-4 0-5 3-5 4s1 1 1 1h4.216ZM4.5 8a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5Z"/>
                                    </svg>)}
                                </Link>
                                Admins
                            </div>) : (<div className="icon-left">
                                {currentRoute === "/Admin" ? (<img src={ic_admin} alt=""/>) : (<svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="16"
                                    height="16"
                                    fill="#16173b"
                                    className="bi bi-people-fill"
                                    viewBox="0 0 16 16"
                                >
                                    <path
                                        d="M7 14s-1 0-1-1 1-4 5-4 5 3 5 4-1 1-1 1H7Zm4-6a3 3 0 1 0 0-6 3 3 0 0 0 0 6Zm-5.784 6A2.238 2.238 0 0 1 5 13c0-1.355.68-2.75 1.936-3.72A6.325 6.325 0 0 0 5 9c-4 0-5 3-5 4s1 1 1 1h4.216ZM4.5 8a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5Z"/>
                                </svg>)}
                            </div>)}
                        </Link>
                    </div>

                    <div
                        className={currentRoute === "/Users" ? "menus-items  active-menu-sidebar" : "menus-items"}
                    >
                        <Link to="/Users" className="icon-menu-name">
                            {sidebar ? (<div className={"menu-name"}>
                                <Link to="/Users" className="me-2">
                                    {currentRoute === "/Users" ? (<img src={ic_user} alt=""/>) : (<svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        width="16"
                                        height="16"
                                        fill="#16173b"
                                        className="bi bi-person-fill"
                                        viewBox="0 0 16 16"
                                    >
                                        <path
                                            d="M3 14s-1 0-1-1 1-4 6-4 6 3 6 4-1 1-1 1H3Zm5-6a3 3 0 1 0 0-6 3 3 0 0 0 0 6Z"/>
                                    </svg>)}
                                </Link>
                                Users
                            </div>) : (<div className="icon-left">
                                {currentRoute === "/Users" ? (<img src={ic_user} alt=""/>) : (<svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="16"
                                    height="16"
                                    fill="#16173b"
                                    className="bi bi-person-fill"
                                    viewBox="0 0 16 16"
                                >
                                    <path
                                        d="M3 14s-1 0-1-1 1-4 6-4 6 3 6 4-1 1-1 1H3Zm5-6a3 3 0 1 0 0-6 3 3 0 0 0 0 6Z"/>
                                </svg>)}
                            </div>)}
                        </Link>
                    </div>

                    <div
                        className={currentRoute === "/VendingMachine" ? "menus-items  active-menu-sidebar" : "menus-items"}
                    >
                        <Link to="/VendingMachine" className="icon-menu-name">
                            {sidebar ? (<div className={"menu-name"}>
                                <Link to="/VendingMachine" className="me-2">
                                    {currentRoute === "/VendingMachine" ? (<img src={ic_machine} alt=""/>) : (<svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        width="1em"
                                        height="1em"
                                        preserveAspectRatio="xMidYMid meet"
                                        viewBox="0 0 24 24"
                                    >
                                        <g
                                            fill="none"
                                            stroke="#16173b"
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                            strokeWidth="2"
                                        >
                                            <rect width="14" height="18" x="5" y="3" rx="2"/>
                                            <circle cx="12" cy="14" r="4"/>
                                            <path
                                                d="M8 6h.01M11 6h.01M14 6h2m-8 8c1.333-.667 2.667-.667 4 0c1.333.667 2.667.667 4 0"/>
                                        </g>
                                    </svg>)}
                                </Link>
                                Vending Machines
                            </div>) : (<div className="icon-left">
                                {currentRoute === "/VendingMachine" ? (<img src={ic_machine} alt=""/>) : (<svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="1em"
                                    height="1em"
                                    preserveAspectRatio="xMidYMid meet"
                                    viewBox="0 0 24 24"
                                >
                                    <g
                                        fill="none"
                                        stroke="#16173b"
                                        stroke-linecap="round"
                                        stroke-linejoin="round"
                                        stroke-width="2"
                                    >
                                        <rect width="14" height="18" x="5" y="3" rx="2"/>
                                        <circle cx="12" cy="14" r="4"/>
                                        <path
                                            d="M8 6h.01M11 6h.01M14 6h2m-8 8c1.333-.667 2.667-.667 4 0c1.333.667 2.667.667 4 0"/>
                                    </g>
                                </svg>)}
                            </div>)}
                        </Link>
                    </div>

                    <div
                        className={currentRoute === "/TransactionLog" ? "menus-items  active-menu-sidebar" : "menus-items"}
                    >
                        <Link to="/TransactionLog" className="icon-menu-name">
                            {sidebar ? (<div className={"menu-name"}>
                                <Link to="/TransactionLog" className="me-2">
                                    {currentRoute === "/TransactionLog" ? (
                                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"
                                             viewBox="0 0 24 24">
                                            <path fill="#fff"
                                                  d="M20 2H10a3 3 0 0 0-3 3v7a3 3 0 0 0 3 3h10a3 3 0 0 0 3-3V5a3 3 0 0 0-3-3Zm1 10a1 1 0 0 1-1 1H10a1 1 0 0 1-1-1V5a1 1 0 0 1 1-1h10a1 1 0 0 1 1 1Zm-3.5-4a1.49 1.49 0 0 0-1 .39a1.5 1.5 0 1 0 0 2.22a1.5 1.5 0 1 0 1-2.61ZM16 17a1 1 0 0 0-1 1v1a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1v-4h1a1 1 0 0 0 0-2H3v-1a1 1 0 0 1 1-1a1 1 0 0 0 0-2a3 3 0 0 0-3 3v7a3 3 0 0 0 3 3h10a3 3 0 0 0 3-3v-1a1 1 0 0 0-1-1ZM6 18h1a1 1 0 0 0 0-2H6a1 1 0 0 0 0 2Z"/>
                                        </svg>) : (<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"
                                                        viewBox="0 0 24 24">
                                        <path fill="#16173b"
                                              d="M20 2H10a3 3 0 0 0-3 3v7a3 3 0 0 0 3 3h10a3 3 0 0 0 3-3V5a3 3 0 0 0-3-3Zm1 10a1 1 0 0 1-1 1H10a1 1 0 0 1-1-1V5a1 1 0 0 1 1-1h10a1 1 0 0 1 1 1Zm-3.5-4a1.49 1.49 0 0 0-1 .39a1.5 1.5 0 1 0 0 2.22a1.5 1.5 0 1 0 1-2.61ZM16 17a1 1 0 0 0-1 1v1a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1v-4h1a1 1 0 0 0 0-2H3v-1a1 1 0 0 1 1-1a1 1 0 0 0 0-2a3 3 0 0 0-3 3v7a3 3 0 0 0 3 3h10a3 3 0 0 0 3-3v-1a1 1 0 0 0-1-1ZM6 18h1a1 1 0 0 0 0-2H6a1 1 0 0 0 0 2Z"/>
                                    </svg>)}
                                </Link>
                                Transaction Log
                            </div>) : (<div className="icon-left">
                                {currentRoute === "/TransactionLog" ? (
                                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"
                                         viewBox="0 0 24 24">
                                        <path fill="#fff"
                                              d="M20 2H10a3 3 0 0 0-3 3v7a3 3 0 0 0 3 3h10a3 3 0 0 0 3-3V5a3 3 0 0 0-3-3Zm1 10a1 1 0 0 1-1 1H10a1 1 0 0 1-1-1V5a1 1 0 0 1 1-1h10a1 1 0 0 1 1 1Zm-3.5-4a1.49 1.49 0 0 0-1 .39a1.5 1.5 0 1 0 0 2.22a1.5 1.5 0 1 0 1-2.61ZM16 17a1 1 0 0 0-1 1v1a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1v-4h1a1 1 0 0 0 0-2H3v-1a1 1 0 0 1 1-1a1 1 0 0 0 0-2a3 3 0 0 0-3 3v7a3 3 0 0 0 3 3h10a3 3 0 0 0 3-3v-1a1 1 0 0 0-1-1ZM6 18h1a1 1 0 0 0 0-2H6a1 1 0 0 0 0 2Z"/>
                                    </svg>) : (<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"
                                                    viewBox="0 0 24 24">
                                    <path fill="#16173b"
                                          d="M20 2H10a3 3 0 0 0-3 3v7a3 3 0 0 0 3 3h10a3 3 0 0 0 3-3V5a3 3 0 0 0-3-3Zm1 10a1 1 0 0 1-1 1H10a1 1 0 0 1-1-1V5a1 1 0 0 1 1-1h10a1 1 0 0 1 1 1Zm-3.5-4a1.49 1.49 0 0 0-1 .39a1.5 1.5 0 1 0 0 2.22a1.5 1.5 0 1 0 1-2.61ZM16 17a1 1 0 0 0-1 1v1a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1v-4h1a1 1 0 0 0 0-2H3v-1a1 1 0 0 1 1-1a1 1 0 0 0 0-2a3 3 0 0 0-3 3v7a3 3 0 0 0 3 3h10a3 3 0 0 0 3-3v-1a1 1 0 0 0-1-1ZM6 18h1a1 1 0 0 0 0-2H6a1 1 0 0 0 0 2Z"/>
                                </svg>)}
                            </div>)}
                        </Link>
                    </div>
                    <div
                        className={currentRoute === "/InventoryLog" ? "menus-items  active-menu-sidebar" : "menus-items"}
                    >
                        <Link to="/InventoryLog" className="icon-menu-name">
                            {sidebar ? (<div className={"menu-name"}>
                                <Link to="/InventoryLog" className="me-2">
                                    {currentRoute === "/InventoryLog" ? (
                                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"
                                             viewBox="0 0 24 24">
                                            <path fill="#fff"
                                                  d="M20 2H10a3 3 0 0 0-3 3v7a3 3 0 0 0 3 3h10a3 3 0 0 0 3-3V5a3 3 0 0 0-3-3Zm1 10a1 1 0 0 1-1 1H10a1 1 0 0 1-1-1V5a1 1 0 0 1 1-1h10a1 1 0 0 1 1 1Zm-3.5-4a1.49 1.49 0 0 0-1 .39a1.5 1.5 0 1 0 0 2.22a1.5 1.5 0 1 0 1-2.61ZM16 17a1 1 0 0 0-1 1v1a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1v-4h1a1 1 0 0 0 0-2H3v-1a1 1 0 0 1 1-1a1 1 0 0 0 0-2a3 3 0 0 0-3 3v7a3 3 0 0 0 3 3h10a3 3 0 0 0 3-3v-1a1 1 0 0 0-1-1ZM6 18h1a1 1 0 0 0 0-2H6a1 1 0 0 0 0 2Z"/>
                                        </svg>) : (<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"
                                                        viewBox="0 0 24 24">
                                        <path fill="#16173b"
                                              d="M20 2H10a3 3 0 0 0-3 3v7a3 3 0 0 0 3 3h10a3 3 0 0 0 3-3V5a3 3 0 0 0-3-3Zm1 10a1 1 0 0 1-1 1H10a1 1 0 0 1-1-1V5a1 1 0 0 1 1-1h10a1 1 0 0 1 1 1Zm-3.5-4a1.49 1.49 0 0 0-1 .39a1.5 1.5 0 1 0 0 2.22a1.5 1.5 0 1 0 1-2.61ZM16 17a1 1 0 0 0-1 1v1a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1v-4h1a1 1 0 0 0 0-2H3v-1a1 1 0 0 1 1-1a1 1 0 0 0 0-2a3 3 0 0 0-3 3v7a3 3 0 0 0 3 3h10a3 3 0 0 0 3-3v-1a1 1 0 0 0-1-1ZM6 18h1a1 1 0 0 0 0-2H6a1 1 0 0 0 0 2Z"/>
                                    </svg>)}
                                </Link>
                                Inventory Log
                            </div>) : (<div className="icon-left">
                                {currentRoute === "/InventoryLog" ? (
                                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"
                                         viewBox="0 0 24 24">
                                        <path fill="#fff"
                                              d="M20 2H10a3 3 0 0 0-3 3v7a3 3 0 0 0 3 3h10a3 3 0 0 0 3-3V5a3 3 0 0 0-3-3Zm1 10a1 1 0 0 1-1 1H10a1 1 0 0 1-1-1V5a1 1 0 0 1 1-1h10a1 1 0 0 1 1 1Zm-3.5-4a1.49 1.49 0 0 0-1 .39a1.5 1.5 0 1 0 0 2.22a1.5 1.5 0 1 0 1-2.61ZM16 17a1 1 0 0 0-1 1v1a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1v-4h1a1 1 0 0 0 0-2H3v-1a1 1 0 0 1 1-1a1 1 0 0 0 0-2a3 3 0 0 0-3 3v7a3 3 0 0 0 3 3h10a3 3 0 0 0 3-3v-1a1 1 0 0 0-1-1ZM6 18h1a1 1 0 0 0 0-2H6a1 1 0 0 0 0 2Z"/>
                                    </svg>) : (<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"
                                                    viewBox="0 0 24 24">
                                    <path fill="#16173b"
                                          d="M20 2H10a3 3 0 0 0-3 3v7a3 3 0 0 0 3 3h10a3 3 0 0 0 3-3V5a3 3 0 0 0-3-3Zm1 10a1 1 0 0 1-1 1H10a1 1 0 0 1-1-1V5a1 1 0 0 1 1-1h10a1 1 0 0 1 1 1Zm-3.5-4a1.49 1.49 0 0 0-1 .39a1.5 1.5 0 1 0 0 2.22a1.5 1.5 0 1 0 1-2.61ZM16 17a1 1 0 0 0-1 1v1a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1v-4h1a1 1 0 0 0 0-2H3v-1a1 1 0 0 1 1-1a1 1 0 0 0 0-2a3 3 0 0 0-3 3v7a3 3 0 0 0 3 3h10a3 3 0 0 0 3-3v-1a1 1 0 0 0-1-1ZM6 18h1a1 1 0 0 0 0-2H6a1 1 0 0 0 0 2Z"/>
                                </svg>)}
                            </div>)}
                        </Link>
                    </div>

                    <div
                        className={currentRoute === "/StockStatement" ? "menus-items  active-menu-sidebar" : "menus-items"}
                    >
                        <Link to="/StockStatement" className="icon-menu-name">
                            {sidebar ? (<div className={"menu-name"}>
                                <Link to="/StockStatement" className="me-2">
                                    {currentRoute === "/StockStatement" ? (
                                        <svg xmlns="http://www.w3.org/2000/svg" width="1024" height="1024"
                                             viewBox="0 0 1024 1024">
                                            <path fill="#fff"
                                                  d="M904 747H120c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h784c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zM165.7 621.8l39.7 39.5c3.1 3.1 8.2 3.1 11.3 0l234.7-233.9l97.6 97.3a32.11 32.11 0 0 0 45.2 0l264.2-263.2c3.1-3.1 3.1-8.2 0-11.3l-39.7-39.6a8.03 8.03 0 0 0-11.3 0l-235.7 235l-97.7-97.3a32.11 32.11 0 0 0-45.2 0L165.7 610.5a7.94 7.94 0 0 0 0 11.3z"/>
                                        </svg>) : (<svg xmlns="http://www.w3.org/2000/svg" width="1024" height="1024"
                                                        viewBox="0 0 1024 1024">
                                        <path fill="#16173b"
                                              d="M904 747H120c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h784c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zM165.7 621.8l39.7 39.5c3.1 3.1 8.2 3.1 11.3 0l234.7-233.9l97.6 97.3a32.11 32.11 0 0 0 45.2 0l264.2-263.2c3.1-3.1 3.1-8.2 0-11.3l-39.7-39.6a8.03 8.03 0 0 0-11.3 0l-235.7 235l-97.7-97.3a32.11 32.11 0 0 0-45.2 0L165.7 610.5a7.94 7.94 0 0 0 0 11.3z"/>
                                    </svg>)}
                                </Link>
                                Stock Statement
                            </div>) : (<div className="icon-left">
                                {currentRoute === "/StockStatement" ? (
                                    <svg xmlns="http://www.w3.org/2000/svg" width="1024" height="1024"
                                         viewBox="0 0 1024 1024">
                                        <path fill="#fff"
                                              d="M904 747H120c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h784c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zM165.7 621.8l39.7 39.5c3.1 3.1 8.2 3.1 11.3 0l234.7-233.9l97.6 97.3a32.11 32.11 0 0 0 45.2 0l264.2-263.2c3.1-3.1 3.1-8.2 0-11.3l-39.7-39.6a8.03 8.03 0 0 0-11.3 0l-235.7 235l-97.7-97.3a32.11 32.11 0 0 0-45.2 0L165.7 610.5a7.94 7.94 0 0 0 0 11.3z"/>
                                    </svg>) : (<svg xmlns="http://www.w3.org/2000/svg" width="1024" height="1024"
                                                    viewBox="0 0 1024 1024">
                                    <path fill="#16173b"
                                          d="M904 747H120c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h784c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zM165.7 621.8l39.7 39.5c3.1 3.1 8.2 3.1 11.3 0l234.7-233.9l97.6 97.3a32.11 32.11 0 0 0 45.2 0l264.2-263.2c3.1-3.1 3.1-8.2 0-11.3l-39.7-39.6a8.03 8.03 0 0 0-11.3 0l-235.7 235l-97.7-97.3a32.11 32.11 0 0 0-45.2 0L165.7 610.5a7.94 7.94 0 0 0 0 11.3z"/>
                                </svg>)}
                            </div>)}
                        </Link>
                    </div>

                    <div
                        className={currentRoute === "/Categories" ? "menus-items  active-menu-sidebar" : "menus-items"}
                    >
                        <Link to="/Categories" className="icon-menu-name">
                            {sidebar ? (<div className={"menu-name"}>
                                <Link to="/Categories" className="me-2">
                                    {currentRoute === "/Categories" ? (<img src={ic_category} alt=""/>) : (<svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        width="24"
                                        height="24"
                                        preserveAspectRatio="xMidYMid meet"
                                        viewBox="0 0 32 32"
                                    >
                                        <path
                                            fill="#16173b"
                                            d="M29 10h-5v2h5v6h-7v2h3v2.142a4 4 0 1 0 2 0V20h2a2.003 2.003 0 0 0 2-2v-6a2.002 2.002 0 0 0-2-2zm-1 16a2 2 0 1 1-2-2a2.003 2.003 0 0 1 2 2zM19 6h-5v2h5v6h-7v2h3v6.142a4 4 0 1 0 2 0V16h2a2.002 2.002 0 0 0 2-2V8a2.002 2.002 0 0 0-2-2zm-1 20a2 2 0 1 1-2-2a2.003 2.003 0 0 1 2 2zM9 2H3a2.002 2.002 0 0 0-2 2v6a2.002 2.002 0 0 0 2 2h2v10.142a4 4 0 1 0 2 0V12h2a2.002 2.002 0 0 0 2-2V4a2.002 2.002 0 0 0-2-2zM8 26a2 2 0 1 1-2-2a2.002 2.002 0 0 1 2 2zM3 10V4h6l.002 6z"
                                        />
                                    </svg>)}
                                </Link>
                                Categories
                            </div>) : (<div className="icon-left">
                                {currentRoute === "/Categories" ? (<img src={ic_category} alt=""/>) : (<svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="24"
                                    height="24"
                                    preserveAspectRatio="xMidYMid meet"
                                    viewBox="0 0 32 32"
                                >
                                    <path
                                        fill="#16173b"
                                        d="M29 10h-5v2h5v6h-7v2h3v2.142a4 4 0 1 0 2 0V20h2a2.003 2.003 0 0 0 2-2v-6a2.002 2.002 0 0 0-2-2zm-1 16a2 2 0 1 1-2-2a2.003 2.003 0 0 1 2 2zM19 6h-5v2h5v6h-7v2h3v6.142a4 4 0 1 0 2 0V16h2a2.002 2.002 0 0 0 2-2V8a2.002 2.002 0 0 0-2-2zm-1 20a2 2 0 1 1-2-2a2.003 2.003 0 0 1 2 2zM9 2H3a2.002 2.002 0 0 0-2 2v6a2.002 2.002 0 0 0 2 2h2v10.142a4 4 0 1 0 2 0V12h2a2.002 2.002 0 0 0 2-2V4a2.002 2.002 0 0 0-2-2zM8 26a2 2 0 1 1-2-2a2.002 2.002 0 0 1 2 2zM3 10V4h6l.002 6z"
                                    />
                                </svg>)}
                            </div>)}
                        </Link>
                    </div>

                    <div
                        className={currentRoute === "/Products" ? "menus-items  active-menu-sidebar" : "menus-items"}
                    >
                        <Link to="/Products" className="icon-menu-name">
                            {sidebar ? (<div className={"menu-name"}>
                                <Link to="/Products" className="me-2">
                                    {currentRoute === "/Products" ? (<img src={ic_product} alt=""/>) : (<svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        width="24"
                                        height="24"
                                        preserveAspectRatio="xMidYMid meet"
                                        viewBox="0 0 2048 2048"
                                    >
                                        <path
                                            fill="#16173b"
                                            d="m1344 2l704 352v785l-128-64V497l-512 256v258l-128 64V753L768 497v227l-128-64V354L1344 2zm0 640l177-89l-463-265l-211 106l497 248zm315-157l182-91l-497-249l-149 75l464 265zm-507 654l-128 64v-1l-384 192v455l384-193v144l-448 224L0 1735v-676l576-288l576 288v80zm-640 710v-455l-384-192v454l384 193zm64-566l369-184l-369-185l-369 185l369 184zm576-1l448-224l448 224v527l-448 224l-448-224v-527zm384 576v-305l-256-128v305l256 128zm384-128v-305l-256 128v305l256-128zm-320-288l241-121l-241-120l-241 120l241 121z"
                                        />
                                    </svg>)}
                                </Link>
                                Products
                            </div>) : (<div className="icon-left">
                                {currentRoute === "/Products" ? (<img src={ic_product} alt=""/>) : (<svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="24"
                                    height="24"
                                    preserveAspectRatio="xMidYMid meet"
                                    viewBox="0 0 2048 2048"
                                >
                                    <path
                                        fill="#16173b"
                                        d="m1344 2l704 352v785l-128-64V497l-512 256v258l-128 64V753L768 497v227l-128-64V354L1344 2zm0 640l177-89l-463-265l-211 106l497 248zm315-157l182-91l-497-249l-149 75l464 265zm-507 654l-128 64v-1l-384 192v455l384-193v144l-448 224L0 1735v-676l576-288l576 288v80zm-640 710v-455l-384-192v454l384 193zm64-566l369-184l-369-185l-369 185l369 184zm576-1l448-224l448 224v527l-448 224l-448-224v-527zm384 576v-305l-256-128v305l256 128zm384-128v-305l-256 128v305l256-128zm-320-288l241-121l-241-120l-241 120l241 121z"
                                    />
                                </svg>)}
                            </div>)}
                        </Link>
                    </div>

                    <div
                        className={currentRoute === "/ProductReviews" ? "menus-items  active-menu-sidebar" : "menus-items"}>
                        <Link to="/ProductReviews" className="icon-menu-name">
                            {sidebar ? (<div className={"menu-name"}>
                                <Link to="/ProductReviews" className="me-2">
                                    {currentRoute === "/ProductReviews" ? (<img src={ic_product} alt=""/>) : (<svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        width="24"
                                        height="24"
                                        preserveAspectRatio="xMidYMid meet"
                                        viewBox="0 0 2048 2048">
                                        <path fill="#16173b"
                                              d="m1344 2l704 352v785l-128-64V497l-512 256v258l-128 64V753L768 497v227l-128-64V354L1344 2zm0 640l177-89l-463-265l-211 106l497 248zm315-157l182-91l-497-249l-149 75l464 265zm-507 654l-128 64v-1l-384 192v455l384-193v144l-448 224L0 1735v-676l576-288l576 288v80zm-640 710v-455l-384-192v454l384 193zm64-566l369-184l-369-185l-369 185l369 184zm576-1l448-224l448 224v527l-448 224l-448-224v-527zm384 576v-305l-256-128v305l256 128zm384-128v-305l-256 128v305l256-128zm-320-288l241-121l-241-120l-241 120l241 121z"/>
                                    </svg>)}
                                </Link>
                                ProductReviews
                            </div>) : (<div className="icon-left">
                                {currentRoute === "/ProductReviews" ? (<img src={ic_product} alt=""/>) : (<svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="24"
                                    height="24"
                                    preserveAspectRatio="xMidYMid meet"
                                    viewBox="0 0 2048 2048">
                                    <path
                                        fill="#16173b"
                                        d="m1344 2l704 352v785l-128-64V497l-512 256v258l-128 64V753L768 497v227l-128-64V354L1344 2zm0 640l177-89l-463-265l-211 106l497 248zm315-157l182-91l-497-249l-149 75l464 265zm-507 654l-128 64v-1l-384 192v455l384-193v144l-448 224L0 1735v-676l576-288l576 288v80zm-640 710v-455l-384-192v454l384 193zm64-566l369-184l-369-185l-369 185l369 184zm576-1l448-224l448 224v527l-448 224l-448-224v-527zm384 576v-305l-256-128v305l256 128zm384-128v-305l-256 128v305l256-128zm-320-288l241-121l-241-120l-241 120l241 121z"
                                    />
                                </svg>)}
                            </div>)}
                        </Link>
                    </div>

                    <div
                        className={currentRoute === "/CouponCodes" ? "menus-items  active-menu-sidebar" : "menus-items"}
                    >
                        <Link to="/CouponCodes" className="icon-menu-name">
                            {sidebar ? (<div className={"menu-name"}>
                                <Link to="/CouponCodes" className="me-2">
                                    {currentRoute === "/CouponCodes" ? (<img src={ic_coupon_code} alt=""/>) : (
                                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16"
                                             fill="#000000"
                                             className="bi bi-hourglass-split" viewBox="0 0 16 16">
                                            <path
                                                d="M2 15.5a.5.5 0 0 0 .5.5h11a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5h-.5v-1a4.5 4.5 0 0 0-2.5-4V8a4.5 4.5 0 0 0 2.5-4V3h.5a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5h-11a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h.5v1a4.5 4.5 0 0 0 2.5 4v1a4.5 4.5 0 0 0-2.5 4v1h-.5a.5.5 0 0 0-.5.5v1zM3 3V2h10v1a3.5 3.5 0 0 1-1.75 3.03L8 8.5 4.75 6.03A3.5 3.5 0 0 1 3 3zm1.75 7.97L8 7.5l3.25 3.47A3.5 3.5 0 0 1 13 12v1H3v-1a3.5 3.5 0 0 1 1.75-3.03z"/>
                                        </svg>)}
                                </Link>
                                Coupon Codes
                            </div>) : (<div className="icon-left">
                                {currentRoute === "/CouponCodes" ? (<img src={ic_coupon_code} alt=""/>) : (
                                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16"
                                         fill="#000000"
                                         className="bi bi-hourglass-split" viewBox="0 0 16 16">
                                        <path
                                            d="M2 15.5a.5.5 0 0 0 .5.5h11a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5h-.5v-1a4.5 4.5 0 0 0-2.5-4V8a4.5 4.5 0 0 0 2.5-4V3h.5a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5h-11a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h.5v1a4.5 4.5 0 0 0 2.5 4v1a4.5 4.5 0 0 0-2.5 4v1h-.5a.5.5 0 0 0-.5.5v1zM3 3V2h10v1a3.5 3.5 0 0 1-1.75 3.03L8 8.5 4.75 6.03A3.5 3.5 0 0 1 3 3zm1.75 7.97L8 7.5l3.25 3.47A3.5 3.5 0 0 1 13 12v1H3v-1a3.5 3.5 0 0 1 1.75-3.03z"/>
                                    </svg>)}
                            </div>)}
                        </Link>
                    </div>

                    <div
                        className={currentRoute === "/Orders" ? "menus-items  active-menu-sidebar" : "menus-items"}
                    >
                        <Link to="/Orders" className="icon-menu-name">
                            {sidebar ? (<div className={"menu-name"}>
                                <Link to="/Orders" className="me-2">
                                    {currentRoute === "/Orders" ? (<img src={ic_order} alt=""/>) : (<svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        width="16"
                                        height="16"
                                        fill="#16173b"
                                        className="bi bi-cart-fill"
                                        viewBox="0 0 16 16"
                                    >
                                        <path
                                            d="M0 1.5A.5.5 0 0 1 .5 1H2a.5.5 0 0 1 .485.379L2.89 3H14.5a.5.5 0 0 1 .491.592l-1.5 8A.5.5 0 0 1 13 12H4a.5.5 0 0 1-.491-.408L2.01 3.607 1.61 2H.5a.5.5 0 0 1-.5-.5zM5 12a2 2 0 1 0 0 4 2 2 0 0 0 0-4zm7 0a2 2 0 1 0 0 4 2 2 0 0 0 0-4zm-7 1a1 1 0 1 1 0 2 1 1 0 0 1 0-2zm7 0a1 1 0 1 1 0 2 1 1 0 0 1 0-2z"/>
                                    </svg>)}
                                </Link>
                                Orders
                            </div>) : (<div className="icon-left">
                                {currentRoute === "/Orders" ? (<img src={ic_order} alt=""/>) : (<svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="16"
                                    height="16"
                                    fill="#16173b"
                                    className="bi bi-cart-fill"
                                    viewBox="0 0 16 16"
                                >
                                    <path
                                        d="M0 1.5A.5.5 0 0 1 .5 1H2a.5.5 0 0 1 .485.379L2.89 3H14.5a.5.5 0 0 1 .491.592l-1.5 8A.5.5 0 0 1 13 12H4a.5.5 0 0 1-.491-.408L2.01 3.607 1.61 2H.5a.5.5 0 0 1-.5-.5zM5 12a2 2 0 1 0 0 4 2 2 0 0 0 0-4zm7 0a2 2 0 1 0 0 4 2 2 0 0 0 0-4zm-7 1a1 1 0 1 1 0 2 1 1 0 0 1 0-2zm7 0a1 1 0 1 1 0 2 1 1 0 0 1 0-2z"/>
                                </svg>)}
                            </div>)}
                        </Link>
                    </div>

                    {/* <div
              className={
                currentRoute === "/TransactionHistory"
                  ? "menus-items  active-menu-sidebar"
                  : "menus-items"
              }
            >
              <Link to="/TransactionHistory" className="icon-menu-name">
                {sidebar ? (
                  <div className={"menu-name"}>
                    <Link to="/TransactionHistory" className="me-2">
                      {currentRoute === "/TransactionHistory" ? (
                        <img src={ic_transaction} alt="" />
                      ) : (
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="24"
                          height="24"
                          preserveAspectRatio="xMidYMid meet"
                          viewBox="0 0 24 24"
                        >
                          <path
                            fill="none"
                            stroke="#16173b"
                            stroke-width="2"
                            d="M2 7h18m-4-5l5 5l-5 5m6 5H4m4-5l-5 5l5 5"
                          />
                        </svg>
                      )}
                    </Link>
                    Transaction History
                  </div>
                ) : (
                  <div className="icon-left">
                    {currentRoute === "/TransactionHistory" ? (
                      <img src={ic_transaction} alt="" />
                    ) : (
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="24"
                        height="24"
                        preserveAspectRatio="xMidYMid meet"
                        viewBox="0 0 24 24"
                      >
                        <path
                          fill="none"
                          stroke="#16173b"
                          stroke-width="2"
                          d="M2 7h18m-4-5l5 5l-5 5m6 5H4m4-5l-5 5l5 5"
                        />
                      </svg>
                    )}
                  </div>
                )}
              </Link>
            </div> */}

                    {/* <div
              className={
                currentRoute === "/QRCodeManagement"
                  ? "menus-items  active-menu-sidebar"
                  : "menus-items"
              }
            >
              <Link to="/QRCodeManagement" className="icon-menu-name">
                {sidebar ? (
                  <div className={"menu-name"}>
                    <Link to="/QRCodeManagement" className="me-2">
                      {currentRoute === "/QRCodeManagement" ? (
                        <img src={ic_qr} alt="" />
                      ) : (
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="24"
                          height="24"
                          preserveAspectRatio="xMidYMid meet"
                          viewBox="0 0 24 24"
                        >
                          <path
                            fill="#16173b"
                            d="M16 17v-1h-3v-3h3v2h2v2h-1v2h-2v2h-2v-3h2v-1h1zm5 4h-4v-2h2v-2h2v4zM3 3h8v8H3V3zm2 2v4h4V5H5zm8-2h8v8h-8V3zm2 2v4h4V5h-4zM3 13h8v8H3v-8zm2 2v4h4v-4H5zm13-2h3v2h-3v-2zM6 6h2v2H6V6zm0 10h2v2H6v-2zM16 6h2v2h-2V6z"
                          />
                        </svg>
                      )}
                    </Link>
                    QR Code Management
                  </div>
                ) : (
                  <div className="icon-left">
                    {currentRoute === "/QRCodeManagement" ? (
                      <img src={ic_qr} alt="" />
                    ) : (
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="24"
                        height="24"
                        preserveAspectRatio="xMidYMid meet"
                        viewBox="0 0 24 24"
                      >
                        <path
                          fill="#16173b"
                          d="M16 17v-1h-3v-3h3v2h2v2h-1v2h-2v2h-2v-3h2v-1h1zm5 4h-4v-2h2v-2h2v4zM3 3h8v8H3V3zm2 2v4h4V5H5zm8-2h8v8h-8V3zm2 2v4h4V5h-4zM3 13h8v8H3v-8zm2 2v4h4v-4H5zm13-2h3v2h-3v-2zM6 6h2v2H6V6zm0 10h2v2H6v-2zM16 6h2v2h-2V6z"
                        />
                      </svg>
                    )}
                  </div>
                )}
              </Link>
            </div> */}

                    <div
                        className={currentRoute === "/TermsAndConditions" ? "menus-items  active-menu-sidebar" : "menus-items"}
                    >
                        <Link to="/TermsAndConditions" className="icon-menu-name">
                            {sidebar ? (<div className={"menu-name"}>
                                <Link to="/TermsAndConditions" className="me-2">
                                    {currentRoute === "/TermsAndConditions" ? (<img src={ic_term} alt=""/>) : (<svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        width="16"
                                        height="16"
                                        fill="#16173b"
                                        className="bi bi-journal-text"
                                        viewBox="0 0 16 16"
                                    >
                                        <path
                                            d="M5 10.5a.5.5 0 0 1 .5-.5h2a.5.5 0 0 1 0 1h-2a.5.5 0 0 1-.5-.5zm0-2a.5.5 0 0 1 .5-.5h5a.5.5 0 0 1 0 1h-5a.5.5 0 0 1-.5-.5zm0-2a.5.5 0 0 1 .5-.5h5a.5.5 0 0 1 0 1h-5a.5.5 0 0 1-.5-.5zm0-2a.5.5 0 0 1 .5-.5h5a.5.5 0 0 1 0 1h-5a.5.5 0 0 1-.5-.5z"/>
                                        <path
                                            d="M3 0h10a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2v-1h1v1a1 1 0 0 0 1 1h10a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1H3a1 1 0 0 0-1 1v1H1V2a2 2 0 0 1 2-2z"/>
                                        <path
                                            d="M1 5v-.5a.5.5 0 0 1 1 0V5h.5a.5.5 0 0 1 0 1h-2a.5.5 0 0 1 0-1H1zm0 3v-.5a.5.5 0 0 1 1 0V8h.5a.5.5 0 0 1 0 1h-2a.5.5 0 0 1 0-1H1zm0 3v-.5a.5.5 0 0 1 1 0v.5h.5a.5.5 0 0 1 0 1h-2a.5.5 0 0 1 0-1H1z"/>
                                    </svg>)}
                                </Link>
                                Terms And Conditions
                            </div>) : (<div className="icon-left">
                                {currentRoute === "/TermsAndConditions" ? (<img src={ic_term} alt=""/>) : (<svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="16"
                                    height="16"
                                    fill="#16173b"
                                    className="bi bi-journal-text"
                                    viewBox="0 0 16 16"
                                >
                                    <path
                                        d="M5 10.5a.5.5 0 0 1 .5-.5h2a.5.5 0 0 1 0 1h-2a.5.5 0 0 1-.5-.5zm0-2a.5.5 0 0 1 .5-.5h5a.5.5 0 0 1 0 1h-5a.5.5 0 0 1-.5-.5zm0-2a.5.5 0 0 1 .5-.5h5a.5.5 0 0 1 0 1h-5a.5.5 0 0 1-.5-.5zm0-2a.5.5 0 0 1 .5-.5h5a.5.5 0 0 1 0 1h-5a.5.5 0 0 1-.5-.5z"/>
                                    <path
                                        d="M3 0h10a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2v-1h1v1a1 1 0 0 0 1 1h10a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1H3a1 1 0 0 0-1 1v1H1V2a2 2 0 0 1 2-2z"/>
                                    <path
                                        d="M1 5v-.5a.5.5 0 0 1 1 0V5h.5a.5.5 0 0 1 0 1h-2a.5.5 0 0 1 0-1H1zm0 3v-.5a.5.5 0 0 1 1 0V8h.5a.5.5 0 0 1 0 1h-2a.5.5 0 0 1 0-1H1zm0 3v-.5a.5.5 0 0 1 1 0v.5h.5a.5.5 0 0 1 0 1h-2a.5.5 0 0 1 0-1H1z"/>
                                </svg>)}
                            </div>)}
                        </Link>
                    </div>

                    <div
                        className={currentRoute === "/PrivacyPolicy" ? "menus-items  active-menu-sidebar" : "menus-items"}
                    >
                        <Link to="/PrivacyPolicy" className="icon-menu-name">
                            {sidebar ? (<div className={"menu-name"}>
                                <Link to="/PrivacyPolicy" className="me-2">
                                    {currentRoute === "/PrivacyPolicy" ? (<img src={ic_privacy} alt=""/>) : (<svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        width="24"
                                        height="24"
                                        preserveAspectRatio="xMidYMid meet"
                                        viewBox="0 0 24 24"
                                    >
                                        <path
                                            fill="#16173b"
                                            d="M6 22q-.825 0-1.412-.587Q4 20.825 4 20V10q0-.825.588-1.413Q5.175 8 6 8h1V6q0-2.075 1.463-3.538Q9.925 1 12 1t3.538 1.462Q17 3.925 17 6v2h1q.825 0 1.413.587Q20 9.175 20 10v10q0 .825-.587 1.413Q18.825 22 18 22Zm0-2h12V10H6v10Zm6-3q.825 0 1.413-.587Q14 15.825 14 15q0-.825-.587-1.413Q12.825 13 12 13q-.825 0-1.412.587Q10 14.175 10 15q0 .825.588 1.413Q11.175 17 12 17ZM9 8h6V6q0-1.25-.875-2.125T12 3q-1.25 0-2.125.875T9 6ZM6 20V10v10Z"
                                        />
                                    </svg>)}
                                </Link>
                                Privacy Policy
                            </div>) : (<div className="icon-left">
                                {currentRoute === "/PrivacyPolicy" ? (<img src={ic_privacy} alt=""/>) : (<svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="24"
                                    height="24"
                                    preserveAspectRatio="xMidYMid meet"
                                    viewBox="0 0 24 24"
                                >
                                    <path
                                        fill="#16173b"
                                        d="M6 22q-.825 0-1.412-.587Q4 20.825 4 20V10q0-.825.588-1.413Q5.175 8 6 8h1V6q0-2.075 1.463-3.538Q9.925 1 12 1t3.538 1.462Q17 3.925 17 6v2h1q.825 0 1.413.587Q20 9.175 20 10v10q0 .825-.587 1.413Q18.825 22 18 22Zm0-2h12V10H6v10Zm6-3q.825 0 1.413-.587Q14 15.825 14 15q0-.825-.587-1.413Q12.825 13 12 13q-.825 0-1.412.587Q10 14.175 10 15q0 .825.588 1.413Q11.175 17 12 17ZM9 8h6V6q0-1.25-.875-2.125T12 3q-1.25 0-2.125.875T9 6ZM6 20V10v10Z"
                                    />
                                </svg>)}
                            </div>)}
                        </Link>
                    </div>
                    {/* <div
              className={
                currentRoute === "/QueryManagement"
                  ? "menus-items  active-menu-sidebar"
                  : "menus-items"
              }
            >
              <Link to="/QueryManagement" className="icon-menu-name">
                {sidebar ? (
                  <div className={"menu-name"}>
                    <Link to="/QueryManagement" className="me-2">
                      {currentRoute === "/QueryManagement" ? (
                        <img src={ic_query} alt="" />
                      ) : (
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="24"
                          height="24"
                          preserveAspectRatio="xMidYMid meet"
                          viewBox="0 0 24 24"
                        >
                          <path
                            fill="#16173b"
                            d="M20 2H4c-1.1 0-2 .9-2 2v18l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2m0 14H5.2L4 17.2V4h16v12M12.2 5.5c-.9 0-1.6.2-2.1.5c-.6.4-.9 1-.8 1.7h2c0-.3.1-.5.3-.6c.2-.1.4-.2.7-.2c.3 0 .6.1.8.3c.2.2.3.4.3.7c0 .3-.1.5-.2.7c-.2.2-.4.4-.6.5c-.5.3-.9.6-1.1.8c-.4.3-.5.6-.5 1.1h2c0-.3.1-.5.1-.7c.1-.2.3-.3.5-.5c.5-.2.8-.5 1.1-.9c.3-.4.4-.8.4-1.2c0-.7-.3-1.3-.8-1.7c-.4-.3-1.2-.5-2.1-.5M11 12v2h2v-2h-2Z"
                          />
                        </svg>
                      )}
                    </Link>
                    Query Management
                  </div>
                ) : (
                  <div className="icon-left">
                    {currentRoute === "/QueryManagement" ? (
                      <img src={ic_query} alt="" />
                    ) : (
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="24"
                        height="24"
                        preserveAspectRatio="xMidYMid meet"
                        viewBox="0 0 24 24"
                      >
                        <path
                          fill="#16173b"
                          d="M20 2H4c-1.1 0-2 .9-2 2v18l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2m0 14H5.2L4 17.2V4h16v12M12.2 5.5c-.9 0-1.6.2-2.1.5c-.6.4-.9 1-.8 1.7h2c0-.3.1-.5.3-.6c.2-.1.4-.2.7-.2c.3 0 .6.1.8.3c.2.2.3.4.3.7c0 .3-.1.5-.2.7c-.2.2-.4.4-.6.5c-.5.3-.9.6-1.1.8c-.4.3-.5.6-.5 1.1h2c0-.3.1-.5.1-.7c.1-.2.3-.3.5-.5c.5-.2.8-.5 1.1-.9c.3-.4.4-.8.4-1.2c0-.7-.3-1.3-.8-1.7c-.4-.3-1.2-.5-2.1-.5M11 12v2h2v-2h-2Z"
                        />
                      </svg>
                    )}
                  </div>
                )}
              </Link>
            </div> */}

                    <div
                        className={currentRoute === "/AboutUs" ? "menus-items  active-menu-sidebar" : "menus-items"}
                    >
                        <Link to="/AboutUs" className="icon-menu-name">
                            {sidebar ? (<div className={"menu-name"}>
                                <Link to="/AboutUs" className="me-2">
                                    {currentRoute === "/AboutUs" ? (<img src={ic_about} alt=""/>) : (<svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        width="24"
                                        height="24"
                                        preserveAspectRatio="xMidYMid meet"
                                        viewBox="0 0 24 24"
                                    >
                                        <path
                                            fill="#16173b"
                                            d="M11 9h2V7h-2m1 13c-4.41 0-8-3.59-8-8s3.59-8 8-8s8 3.59 8 8s-3.59 8-8 8m0-18A10 10 0 0 0 2 12a10 10 0 0 0 10 10a10 10 0 0 0 10-10A10 10 0 0 0 12 2m-1 15h2v-6h-2v6Z"
                                        />
                                    </svg>)}
                                </Link>
                                About Us
                            </div>) : (<div className="icon-left">
                                {currentRoute === "/AboutUs" ? (<img src={ic_about} alt=""/>) : (<svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="24"
                                    height="24"
                                    preserveAspectRatio="xMidYMid meet"
                                    viewBox="0 0 24 24"
                                >
                                    <path
                                        fill="#16173b"
                                        d="M11 9h2V7h-2m1 13c-4.41 0-8-3.59-8-8s3.59-8 8-8s8 3.59 8 8s-3.59 8-8 8m0-18A10 10 0 0 0 2 12a10 10 0 0 0 10 10a10 10 0 0 0 10-10A10 10 0 0 0 12 2m-1 15h2v-6h-2v6Z"
                                    />
                                </svg>)}
                            </div>)}
                        </Link>
                    </div>
                </div>
            </aside>
        </div>
    </main>);
};

export default Sidebar;
